import React, { memo, useEffect, useRef, useState } from "react";
import "./CardSparkAnimation.css";
import CardCSS from "../Card/Card";
import glowSnd from "../../assets/sounds/successNew.mp3"
import burst1 from "../../assets/sounds/burst1.mp3"
import burst2 from "../../assets/sounds/burst2.mp3"
import burst_sm_1 from "../../assets/sounds/burst-sm-1.mp3"
import burst_sm_2 from "../../assets/sounds/burst-sm-2.mp3"
import { Howl } from "howler";

const CardSparkAnimation = memo(({ winAmount = 1000, onAnimationEnd = () => { } }) => {
    const canvasRef = useRef(null);
    const particles = useRef([]);
    const animationRef = useRef(null);
    const cards = ["AS", "AH", "AC", "AD"]
    const [glowSound, setGlowSound] = useState(new Howl({ src: [glowSnd], html5: true, }))

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let cw = (canvas.width = window.innerWidth);
        let ch = (canvas.height = window.innerHeight);

        const resize = () => {
            cw = canvas.width = window.innerWidth;
            ch = canvas.height = window.innerHeight;
        };
        window.addEventListener("resize", resize);

        class Particle {
            constructor(x, y, hue, size, life, isGold = false) {
                this.x = x;
                this.y = y;
                this.hue = hue;
                this.size = size;
                this.life = life;
                this.alpha = 1;
                this.isGold = isGold;

                const angle = Math.random() * Math.PI * 2;
                const speed = Math.random() * 5 + 2; // controlled radius
                this.vx = Math.cos(angle) * speed;
                this.vy = Math.sin(angle) * speed;
            }
            update() {
                this.x += this.vx;
                this.y += this.vy;
                this.alpha -= 1 / this.life;
                this.life--;
            }
            draw(ctx) {
                ctx.save();
                ctx.globalAlpha = this.alpha;
                ctx.fillStyle = this.isGold
                    ? `hsl(50, 100%, 50%)` // gold
                    : `hsl(${this.hue}, 100%, 55%)`; // vibrant but not white
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        }

        const createBlast = (x, y, hue, big = false, sound) => {
            const count = big ? 180 : 100;
            const size = window.innerHeight < window.innerWidth ? (big ? 8 : 5) : (big ? 5 : 3);
            const life = 180;

            // Play sound ONCE per blast
            if (sound) {
                new Howl({ src: [sound], html5: true }).play();
            }

            for (let i = 0; i < count; i++) {
                const chosenHue = Array.isArray(hue)
                    ? hue[Math.floor(Math.random() * hue.length)]
                    : hue;

                particles.current.push(
                    new Particle(
                        x,
                        y,
                        chosenHue,
                        size + Math.random() * 2,
                        life,
                        big && chosenHue === 50
                    )
                );
            }
        };



        // Predefined sequence: 5 blasts over 3s
        const sequence = [
            { x: cw / 2, y: ch / 2, hue: 50, big: true, sound: burst1 },     // gold center
            { x: cw * 0.25, y: ch * 0.25, hue: 220, sound: burst_sm_1 }, // blue top-left
            { x: cw * 0.75, y: ch * 0.25, hue: 120, sound: burst_sm_2 }, // green top-right
            { x: cw * 0.25, y: ch * 0.75, hue: 280, sound: burst_sm_1 }, // purple bottom-left
            { x: cw * 0.75, y: ch * 0.75, hue: 280, sound: burst_sm_2 }, // purple bottom-left
            { x: cw / 2, y: ch / 2, hue: [50, 330], big: true, sound: burst2 }, // big gold + pink finale
        ];

        let step = 0;
        const stepInterval = setInterval(() => {
            if (step < sequence.length) {
                const { x, y, hue, big, sound } = sequence[step];
                createBlast(x, y, hue, big, sound);
                step++;
            } else {
                onAnimationEnd()
                clearInterval(stepInterval);
            }
        }, 400); // 5 blasts in ~3s (600ms apart)

        const animate = () => {
            ctx.globalCompositeOperation = "destination-out";
            ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
            ctx.fillRect(0, 0, cw, ch);

            ctx.globalCompositeOperation = "lighter";

            for (let i = particles.current.length - 1; i >= 0; i--) {
                const p = particles.current[i];
                if (p.life <= 0 || p.alpha <= 0) {
                    particles.current.splice(i, 1);
                } else {
                    p.update();
                    p.draw(ctx);
                }
            }
            animationRef.current = requestAnimationFrame(animate);
        };

        animate();
        if (glowSound) {
            glowSound?.stop()
            glowSound?.play()
        } else {
            let sound = new Howl({ src: [glowSound], html5: true, })
            sound?.stop()
            sound?.play()
        }
        return () => {
            window.removeEventListener("resize", resize);
            clearInterval(stepInterval);
            cancelAnimationFrame(animationRef.current);
        };
    }, []);

    return (
        <div id="cardSparkAnimation">
            {/* Fireworks Canvas */}
            <canvas ref={canvasRef} className="sparkCanvas"></canvas>

            {/* Win UI */}
            <div id="winMain">
                <div id="winCircleMain">
                    <div id="winCircleMain_inner" />
                    {cards?.map((ele, i) => (
                        <CardCSS
                            key={i}
                            cardTitle={ele}
                            newClassName={`card${i + 1}`}
                            index={`${-45 + 30 * i}deg`}
                        />
                    ))}
                    <div id="winText">
                        <h1 id="Winner">Winner</h1>
                        <p id="winAmt">{winAmount}</p>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CardSparkAnimation;
